__turbopack_context__.v({
  "styledAvatarGroup": "Avatars-module__Dk7mbq__styledAvatarGroup",
});
